<template functional>
  <div :class="'alert alert-' + infoType[kycDocument.Status]">
    <p>Status: {{ documentStatus }}</p>
    <p>
      {{ `${$t('profile.kyc.document.creationDate')}: ${creationDate}` }}
    </p>
    <p v-if="kycDocument.ProcessedDate">
      {{ `${$t('profile.kyc.document.processedDate')}: ${processedDate}` }}
    </p>
    <p v-if="kycDocument.RefusedReasonType">
      {{ `${$t('profile.kyc.document.reason')}: ${kycDocument.RefusedReasonType.replace('_', ' ').toLowerCase()}` }}
    </p>
    <p v-if="kycDocument.RefusedReasonMessage">
      {{ kycDocument.RefusedReasonMessage }}
    </p>
  </div>
</template>

<script>
function timestampToLocaleString(timestamp) {
  return new Date(timestamp * 1000).toLocaleString();
}

export default {
  props: {
    kycDocument: {
      type: Object,
      default: {},
    },
  },
  computed: {
    infoType() {
      return {
        CREATED: 'warning',
        VALIDATION_ASKED: 'info',
        VALIDATED: 'success',
        REFUSED: 'danger',
      };
    },
    creationDate() {
      return timestampToLocaleString(this.kycDocument.CreationDate);
    },
    processedDate() {
      return timestampToLocaleString(this.kycDocument.ProcessedDate);
    },
    documentStatus() {
      return this.$t(`profile.kyc.document.status.${[this.kycDocument.Status]}`);
    },
  },
};
</script>

<style scoped>
.alert p {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// Status.vue?1345205c